"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var fa_1 = require("react-icons/fa");
var reactstrap_1 = require("reactstrap");
var reactstrap_2 = require("reactstrap");
var AppContext_1 = require("../AppContext");
var LoadScreenComponent_1 = require("./base/LoadScreenComponent");
var SplashScreenComponent_1 = require("./base/SplashScreenComponent");
var StyleComponents_1 = require("./base/StyleComponents");
var Footer_1 = require("./Footer");
var NavMenu_1 = require("./NavMenu");
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Layout.prototype.render = function () {
        console.log(this.context);
        return (React.createElement("div", { style: { overflow: 'hidden' } },
            React.createElement(NavMenu_1.NavMenu, null),
            React.createElement(reactstrap_2.Container, { className: "p-0", fluid: true, style: { paddingBottom: '1em' } }, this.props.children),
            React.createElement(Footer_1.Footer, null),
            this.context.loadingCount > 0 && React.createElement(LoadScreenComponent_1.default, null),
            !this.context.ageConfirmed && React.createElement(AgeQuestionScreen, null)));
    };
    Layout.contextType = AppContext_1.AppContext;
    return Layout;
}(React.PureComponent));
exports.default = Layout;
var AgeQuestionScreen = function () {
    var context = React.useContext(AppContext_1.AppContext);
    var yes = function () {
        context.confirmAge();
    };
    var no = function () {
        window.location.href = 'https://google.com';
    };
    return (React.createElement(SplashScreenComponent_1.default, null,
        React.createElement(StyleComponents_1.CenterComponent, { width: "100%", height: "100%" },
            React.createElement(StyleComponents_1.Flexbox, null,
                React.createElement(reactstrap_1.Media, { style: {
                        maxWidth: '80%'
                    }, object: true, src: 'image/logo_cieniowane_pelne_male.png', alt: "Brak logo" }),
                React.createElement("br", null),
                React.createElement("div", { style: { fontSize: 30 } },
                    React.createElement("p", null, "Czy uko\u0144czy\u0142e\u015B 18 lat?"),
                    React.createElement("span", { className: 'hovered-text', style: {
                            marginRight: '1em',
                            cursor: 'pointer',
                            "&:hover": {
                                color: "white"
                            },
                        }, onClick: function () { return yes(); } }, "TAK"),
                    React.createElement("span", { className: 'hovered-text', style: {
                            marginLeft: '1em',
                            cursor: 'pointer',
                        }, onClick: function () { return no(); } }, "NIE"))))));
};
var SocialMediaShortcut = function () {
    return (React.createElement("div", { style: {
            position: 'fixed',
            right: 0,
            bottom: '20vh',
            fontSize: 40,
            //width: 40,
            //height: 40,
            backgroundColor: 'white',
            color: 'blue'
        } },
        React.createElement(fa_1.FaFacebookSquare, null)));
};
//# sourceMappingURL=Layout.js.map